import React from 'react'
import { Splide, SplideSlide } from '@splidejs/react-splide'
import '@splidejs/splide/dist/css/themes/splide-default.min.css'
import PropTypes from 'prop-types'

class Slider extends React.Component {
  render() {
    const { slides, activeFilter, isMD, isSM } = this.props

    const filteredSlides = slides.filter(
      slide =>
        !activeFilter ||
        (slide.categories &&
          slide.categories.some(category => category.name === activeFilter))
    )

    return (
      <Splide
        options={{
          type: 'loop',
          perPage: isSM ? 1 : isMD ? 2 : 3,
          perMove: 1,
          pagination: false,
          autoplay: true,
        }}
      >
        {filteredSlides.map((slide, i) => (
          <SplideSlide key={`${i}-${activeFilter}`}>
            <div>
              <div className="slider-border">
                <img
                  className="slider-image lazyload"
                  data-src={slide.image.url}
                  alt={slide.image.alt || slide.title}
                />
                <div className="meta">
                  {slide.categories &&
                    slide.categories.map(category => (
                      <p key={category.id}>
                        <span className="tag">{category.name}</span>
                      </p>
                    ))}
                  {!slide.categories ||
                    (slide.categories.length === 0 && (
                      <span className="placeholder"></span>
                    ))}
                </div>
                <div className="p-15">
                  <div className="ctncon">
                    <p className={'h2'}>{slide.title}</p>
                    <p className="h3">{slide.subline}</p>
                    <div className="row">
                      <div className="col-12 col-lg-6">
                        {slide.weiterlesenlink && (
                          <a
                            className="button icon"
                            href={slide.weiterlesenlink.link}
                            dangerouslySetInnerHTML={{
                              __html:
                                slide.weiterlesenlink.title +
                                '<i class="btb bt-arrow-right"></i>',
                            }}
                          />
                        )}
                      </div>
                      <div className="col-12 col-lg-6">
                        {slide.shoplink && (
                          <div className="button-hover">
                            <a
                              className="button icon"
                              href={slide.shoplink.link}
                              dangerouslySetInnerHTML={{
                                __html:
                                  slide.shoplink.title +
                                  '<span class="btb shop-icon"></span>',
                              }}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </SplideSlide>
        ))}
      </Splide>
    )
  }
}

Slider.propTypes = {
  slides: PropTypes.array.isRequired,
  activeFilter: PropTypes.string,
  isMD: PropTypes.bool,
  isSM: PropTypes.bool,
}

export default Slider
